<template>
<m-pageframe
    title="Reservation Time Zones"
>
<v-container
    fluid
    style="padding: 15px"
>

    <p>Not seeing the options you expect?  You can refresh your meta data by <a v-on:click="onClickUpdateMetaData">clicking here</a></p>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical-circle-outline
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickChange(item)"
                >
                    <v-list-item-title>Change Time Zone...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {
    data() {
        return {
            results: [],
            full_text: null,

            headers: [
                { text: 'Label', value: 'location_label'},
                { text: 'Time Zone', value: 'zone'},
                { text: 'Action', value: 'action'},
            ],
        }
    },

    mounted () {
        this.doUpdate();
    },    

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/integrations/crm/reservations/location_tz',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to list reservation locations',
            });
        },

        onClickUpdateMetaData()
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'PUT: /api/v1/auto-messages/conditions/update-conditional-values',
            
                {
                    'organization_id': this.$route.params.organization_id,
                    'message_pattern_context': 'auto-message-reservation-reminder-morning-of',
                },
            
                (data) => {
                    this.$rc.hideSpinner();
                    this.doUpdate();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to update meta data');
                },
            );
        },

        onClickChange(item)
        {
            this.$rc.pick({
                'title': 'Select Time Zone',
                'content_before': null,
                'content_after': null,
            
                'choices': 'timezone',
            
                'multiple': false,
                'type': 'select',
                'select_label': 'Time Zone',
                'initial_value': item.zone,
            
                'on_ok': (value) => {

                    this.$rc.rest({
                        'spinner': true,
                        'endpoint': 'PUT: /api/v1/integrations/crm/reservations/location_tz',
                    
                        'params' : {
                                'organization_id': item.organization_id,
                                'location_id': item.location_id,
                                'zone': value
                            },
                    
                        'on_success': (data) => {
                                this.doUpdate();
                            },
                    
                        'on_error': 'Unable to update location time zone',
                    });
                   
                },
            
                'on_cancel': () => {}
            });
        },
        
    },
}
</script>

<style lang="scss" scoped>
</style>
